module.exports = __webpack_public_path__ + "img/IMG_0459_L_Foamcore.c7adea10.jpg";